import {both, pathEq } from 'ramda'

export const isSessionExpireError =  both(
    pathEq([ "request", "status" ], 401),
    pathEq([ "response", "data", "detail"], 'Session expired')
  )
